import { format } from "date-fns"

type Props = {
  date: string,
  name: string,
  onClick: () => void
}

const PostHistory = ({ onClick, name, date }: Props) => {
  return (
    <div
      onClick={onClick}
      className='flex items-center gap-2 flex-1 h-[4rem] border border-purple-300 rounded-xl px-3 py-2 shadow-md shadow-purple-300'>
      <span className='flex flex-col gap-0 h-full aspect-square items-center justify-center bg-purple-600 text-white p-2 rounded-lg'>
        <p className='font-poppins text-xs font-medium'>{format(new Date(date), 'MMM')}</p>
        <p className='font-semibold font-poppins'>{format(new Date(date), 'd')}</p>
      </span>
      <h3 className='font-poppins text-sm tracking-wide font-medium'>{name}</h3>
    </div>
  )
}

export default PostHistory
